import { render, staticRenderFns } from "./TeamsCount.vue?vue&type=template&id=1c80bbfa&scoped=true&"
import script from "./TeamsCount.vue?vue&type=script&lang=js&"
export * from "./TeamsCount.vue?vue&type=script&lang=js&"
import style0 from "./TeamsCount.vue?vue&type=style&index=0&id=1c80bbfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c80bbfa",
  null
  
)

export default component.exports